import NavBar from './Navbar'
import './styles.css'

export default function Dashboard() {

  return (
    <div>
      <NavBar />
      <main className='container-md main-content fs-root'>
        <h3>Hi! This is page NAGLOG</h3>
      </main>
    </div>
  )
}
